// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/get_account.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { WorkFunction } from "../general/work_function_pb";
import { file_general_work_function } from "../general/work_function_pb";
import type { WorkDepartment } from "../general/work_department_pb";
import { file_general_work_department } from "../general/work_department_pb";
import type { WorkLocation } from "../general/work_location_pb";
import { file_general_work_location } from "../general/work_location_pb";
import type { ShowcaseLayoutType } from "./showcase_layout_type_pb";
import { file_accounts_showcase_layout_type } from "./showcase_layout_type_pb";
import type { ProfileCover } from "./profile_cover_pb";
import { file_accounts_profile_cover } from "./profile_cover_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/get_account.proto.
 */
export const file_accounts_get_account: GenFile = /*@__PURE__*/
  fileDesc("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", [file_general_work_function, file_general_work_department, file_general_work_location, file_accounts_showcase_layout_type, file_accounts_profile_cover]);

/**
 * @generated from message protos.accounts.GetAccountRequest
 */
export type GetAccountRequest = Message<"protos.accounts.GetAccountRequest"> & {
  /**
   * @generated from field: protos.accounts.GetAccountRequest.Params params = 1;
   */
  params?: GetAccountRequest_Params | undefined;
};

/**
 * Describes the message protos.accounts.GetAccountRequest.
 * Use `create(GetAccountRequestSchema)` to create a new message.
 */
export const GetAccountRequestSchema: GenMessage<GetAccountRequest> = /*@__PURE__*/
  messageDesc(file_accounts_get_account, 0);

/**
 * @generated from message protos.accounts.GetAccountRequest.Params
 */
export type GetAccountRequest_Params = Message<"protos.accounts.GetAccountRequest.Params"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: bool include_union_memberships = 2;
   */
  includeUnionMemberships: boolean;
};

/**
 * Describes the message protos.accounts.GetAccountRequest.Params.
 * Use `create(GetAccountRequest_ParamsSchema)` to create a new message.
 */
export const GetAccountRequest_ParamsSchema: GenMessage<GetAccountRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_get_account, 0, 0);

/**
 * @generated from message protos.accounts.GetAccountResponse
 */
export type GetAccountResponse = Message<"protos.accounts.GetAccountResponse"> & {
  /**
   * @generated from field: protos.accounts.GetAccountResponse.Result result = 1;
   */
  result?: GetAccountResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.GetAccountResponse.
 * Use `create(GetAccountResponseSchema)` to create a new message.
 */
export const GetAccountResponseSchema: GenMessage<GetAccountResponse> = /*@__PURE__*/
  messageDesc(file_accounts_get_account, 1);

/**
 * @generated from message protos.accounts.GetAccountResponse.Result
 */
export type GetAccountResponse_Result = Message<"protos.accounts.GetAccountResponse.Result"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string bio = 3;
   */
  bio: string;

  /**
   * @generated from field: string pfp_url = 4;
   */
  pfpUrl: string;

  /**
   * @generated from field: repeated protos.accounts.ProfileCover covers = 5;
   */
  covers: ProfileCover[];

  /**
   * @generated from field: protos.accounts.ShowcaseLayoutType showcase_layout_type = 6;
   */
  showcaseLayoutType: ShowcaseLayoutType;

  /**
   * @generated from field: protos.accounts.GetAccountResponse.Result.Contact contact = 7;
   */
  contact?: GetAccountResponse_Result_Contact | undefined;

  /**
   * @generated from field: protos.accounts.GetAccountResponse.Result.WorkFunctionData main_work_function = 8;
   */
  mainWorkFunction?: GetAccountResponse_Result_WorkFunctionData | undefined;

  /**
   * @generated from field: protos.general.WorkLocation main_work_location = 9;
   */
  mainWorkLocation: WorkLocation;

  /**
   * @generated from field: bool is_blocked = 10;
   */
  isBlocked: boolean;

  /**
   * @generated from field: repeated protos.accounts.GetAccountResponse.Result.WorkFunctionData other_work_functions = 11;
   */
  otherWorkFunctions: GetAccountResponse_Result_WorkFunctionData[];

  /**
   * @generated from field: repeated protos.accounts.GetAccountResponse.Result.UnionMembership union_memberships = 12;
   */
  unionMemberships: GetAccountResponse_Result_UnionMembership[];

  /**
   * We'll remove this in the future so use a higher number
   *
   * @generated from field: protos.accounts.GetAccountResponse.Result.SocialLinks social_links = 101;
   */
  socialLinks?: GetAccountResponse_Result_SocialLinks | undefined;
};

/**
 * Describes the message protos.accounts.GetAccountResponse.Result.
 * Use `create(GetAccountResponse_ResultSchema)` to create a new message.
 */
export const GetAccountResponse_ResultSchema: GenMessage<GetAccountResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_get_account, 1, 0);

/**
 * @generated from message protos.accounts.GetAccountResponse.Result.WorkFunctionData
 */
export type GetAccountResponse_Result_WorkFunctionData = Message<"protos.accounts.GetAccountResponse.Result.WorkFunctionData"> & {
  /**
   * @generated from field: protos.general.WorkFunction function = 1;
   */
  function: WorkFunction;

  /**
   * @generated from field: protos.general.WorkDepartment department = 2;
   */
  department: WorkDepartment;
};

/**
 * Describes the message protos.accounts.GetAccountResponse.Result.WorkFunctionData.
 * Use `create(GetAccountResponse_Result_WorkFunctionDataSchema)` to create a new message.
 */
export const GetAccountResponse_Result_WorkFunctionDataSchema: GenMessage<GetAccountResponse_Result_WorkFunctionData> = /*@__PURE__*/
  messageDesc(file_accounts_get_account, 1, 0, 0);

/**
 * @generated from message protos.accounts.GetAccountResponse.Result.Contact
 */
export type GetAccountResponse_Result_Contact = Message<"protos.accounts.GetAccountResponse.Result.Contact"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string phone_number = 2;
   */
  phoneNumber: string;

  /**
   * @generated from field: string website = 3;
   */
  website: string;
};

/**
 * Describes the message protos.accounts.GetAccountResponse.Result.Contact.
 * Use `create(GetAccountResponse_Result_ContactSchema)` to create a new message.
 */
export const GetAccountResponse_Result_ContactSchema: GenMessage<GetAccountResponse_Result_Contact> = /*@__PURE__*/
  messageDesc(file_accounts_get_account, 1, 0, 1);

/**
 * @generated from message protos.accounts.GetAccountResponse.Result.SocialLinks
 */
export type GetAccountResponse_Result_SocialLinks = Message<"protos.accounts.GetAccountResponse.Result.SocialLinks"> & {
  /**
   * @generated from field: string instagram = 1;
   */
  instagram: string;

  /**
   * @generated from field: string facebook = 2;
   */
  facebook: string;

  /**
   * @generated from field: string linkedin = 3;
   */
  linkedin: string;

  /**
   * @generated from field: string imdb = 4;
   */
  imdb: string;
};

/**
 * Describes the message protos.accounts.GetAccountResponse.Result.SocialLinks.
 * Use `create(GetAccountResponse_Result_SocialLinksSchema)` to create a new message.
 */
export const GetAccountResponse_Result_SocialLinksSchema: GenMessage<GetAccountResponse_Result_SocialLinks> = /*@__PURE__*/
  messageDesc(file_accounts_get_account, 1, 0, 2);

/**
 * @generated from message protos.accounts.GetAccountResponse.Result.UnionMembership
 */
export type GetAccountResponse_Result_UnionMembership = Message<"protos.accounts.GetAccountResponse.Result.UnionMembership"> & {
  /**
   * @generated from field: string union_id = 1;
   */
  unionId: string;

  /**
   * @generated from field: uint32 year_joined = 2;
   */
  yearJoined: number;

  /**
   * @generated from field: string membership_status = 3;
   */
  membershipStatus: string;

  /**
   * @generated from field: string membership_id = 4;
   */
  membershipId: string;

  /**
   * @generated from field: repeated protos.accounts.GetAccountResponse.Result.UnionMembership.CertifiedFunction certified_functions = 5;
   */
  certifiedFunctions: GetAccountResponse_Result_UnionMembership_CertifiedFunction[];
};

/**
 * Describes the message protos.accounts.GetAccountResponse.Result.UnionMembership.
 * Use `create(GetAccountResponse_Result_UnionMembershipSchema)` to create a new message.
 */
export const GetAccountResponse_Result_UnionMembershipSchema: GenMessage<GetAccountResponse_Result_UnionMembership> = /*@__PURE__*/
  messageDesc(file_accounts_get_account, 1, 0, 3);

/**
 * @generated from message protos.accounts.GetAccountResponse.Result.UnionMembership.CertifiedFunction
 */
export type GetAccountResponse_Result_UnionMembership_CertifiedFunction = Message<"protos.accounts.GetAccountResponse.Result.UnionMembership.CertifiedFunction"> & {
  /**
   * @generated from field: protos.general.WorkFunction function = 1;
   */
  function: WorkFunction;
};

/**
 * Describes the message protos.accounts.GetAccountResponse.Result.UnionMembership.CertifiedFunction.
 * Use `create(GetAccountResponse_Result_UnionMembership_CertifiedFunctionSchema)` to create a new message.
 */
export const GetAccountResponse_Result_UnionMembership_CertifiedFunctionSchema: GenMessage<GetAccountResponse_Result_UnionMembership_CertifiedFunction> = /*@__PURE__*/
  messageDesc(file_accounts_get_account, 1, 0, 3, 0);

